import axios from "./axios"

/**
 * 查詢前返回簡單資料（申請方式：手機/一戶通）
 * @param {*} serviceType 
 * @param {*} spNo 
 * @param {*} type 
 * @returns 
 */
const getBySpNo = (serviceType, spNo, type, changeType) => {
    return axios.get(`/public/api/v1/application${type?type:''}/${serviceType}?spNo=${spNo}${changeType ? `&changeType=${changeType}` : ''}`).then(res => res.data);
}

/**
 * 查詢前返回簡單資料（申請方式：手機/一戶通）
 * sp編號或車輛註冊編號
 * @param {*} serviceType 
 * @param {*} spNo 
 * @param {*} registrationNo 
 * @param {*} identificationNo 
 */
const getBySpOrReg = (serviceType, spNo, registrationNo = null, identificationNo = null) => {
    return axios.get(`/public/api/v1/application/${serviceType}?${spNo ? `spNo=${spNo}`:`registrationNo=${registrationNo}&identificationNo=${identificationNo}`}`).then(res => res.data);
}

export default {
    getBySpNo,
    getBySpOrReg
}